export default {"src":"/_next/static/media/FacebookMessenger.968b1221.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};